{
	"presetExported": "{{name}} exported",
	"presetImportLutError": "Preset imported, but its LUT data could not be restored.",
	"removePresetGroupMessage": "Removing a preset group is not undoable. Are you sure you want to remove this preset group and all of the presets it contains?",
	"removePresetGroupTitle": "Permanently Remove Preset Group: {{group}}"
}
